module.exports = __webpack_public_path__ + "img/banner-bahia-mobile.fc699128.png";